import React, { useEffect, useState } from 'react';
import ProductSubCategoryModel from './models/ProductSubCategoryModel';

function DeleteProductSubCategory({ SubCategoryData }) {
  const [selected, setSelected] = useState(new ProductSubCategoryModel());

  useEffect(() => {
    setSelected(SubCategoryData || new ProductSubCategoryModel());
  }, [SubCategoryData]);

  return (
    <div className="text-left px-2 pb-0">
      <h6>Following sub category will be deleted and cannot be recovered:</h6>
      <ul>
        <li>
          <b>Category:</b> {selected.CategoryName}
        </li>
        <li>
          <b>Sub Category Name:</b> {selected.SubCategoryName}
        </li>
        <li>
          <b>Slug:</b> {selected.Slug || 'N/A'}
        </li>
        <li>
          <b>Display Order:</b> {selected.DisplayOrder ?? 0}
        </li>
      </ul>
    </div>
  );
}

export default DeleteProductSubCategory;
